import { render } from "./SendToInfo.vue?vue&type=template&id=2b82c90e"
import script from "./SendToInfo.vue?vue&type=script&lang=js"
export * from "./SendToInfo.vue?vue&type=script&lang=js"

import "./SendToInfo.vue?vue&type=style&index=0&id=2b82c90e&lang=scss"

import exportComponent from "D:\\Source\\mobaxe\\mobaxe.docs.app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__